export default [
  {
    path: "/app/reports",
    component: () => import("../views"),
    meta: {
      title: "Educasis - Relatórios",
      requiresAuth: true,
    },
    children: [
      // Documents
      // Bulletins
      {
        path: "students/bulletin",
        name: "reports.students.bulletin",
        component: () =>
          import("../documents/bulletins/student/views/List.vue"),
        meta: {
          permission: "view_student_bulletin_report",
        },
      },
      {
        path: "teachers/bulletin",
        name: "reports.teachers-bulletin",
        component: () =>
          import("../documents/bulletins/teacher/views/List.vue"),
        meta: {
          permission: "view_teacher_bulletin_report",
        },
      },
      {
        path: "documents/class-diary",
        name: "documents.class-diary",
        component: () => import("../documents/class-diary/views/List.vue"),
        meta: {
          permission: "view_class_diary_report",
        },
      },
      {
        path: "documents/record-student",
        name: "documents.record-student",
        component: () => import("../documents/record/student/views/List.vue"),
        meta: {
          permission: "view_student_record",
        },
      },
      {
        path: "documents/record-server",
        name: "documents.record-server",
        component: () => import("../documents/record/server/views/List.vue"),
        meta: {
          permission: "view_server_record",
        },
      },
      // Attested
      {
        path: "documents/attested/attested-frequency",
        name: "documents.attested.attested-frequency",
        component: () =>
          import("../documents/attested/attested-frequency/views/List.vue"),
        meta: {
          permission: "view_report_attested_frequency",
        },
      },
      {
        path: "documents/attested/attested-registration",
        name: "documents.attested.attested-registration",
        component: () =>
          import("../documents/attested/attested-registration/views/List.vue"),
        meta: {
          permission: "view_report_attested_registration",
        },
      },
      {
        path: "documents/attested/attested-transferency",
        name: "documents.attested.attested-transferency",
        component: () =>
          import("../documents/attested/attested-transferency/views/List.vue"),
        meta: {
          permission: "view_report_attested_transferency",
        },
      },
      {
        path: "documents/attested/attested-conclusion",
        name: "documents.attested.attested-conclusion",
        component: () =>
          import("../documents/attested/attested-conclusion/views/List.vue"),
        meta: {
          permission: "view_report_attested_conclusion",
        },
      },
      {
        path: "documents/attested/attested-conclusion-diplome",
        name: "documents.attested.attested-conclusion-diplome",
        component: () =>
          import("../documents/attested/attested-conclusion-diplome/views/List.vue"),
        meta: {
          permission: "view_report_attested_conclusion_diplome",
        },
      },
      {
        path: "documents/attested/attested-vacancy",
        name: "documents.attested.attested-vacancy",
        component: () =>
          import("../documents/attested/attested-vacancy/views/List.vue"),
        meta: {
          permission: "view_report_attested_vacancy",
        },
      },
      // Calendar
      {
        path: "documents/calendar/school",
        name: "documents.calendar.school",
        component: () => import("../documents/calendar/school/views/List.vue"),
        meta: {
          permission: "view_calendar_events_report",
        },
      },
      // Documents
      /*  {
        path: "planning",
        name: "documents.planning",
        component: () => import("../documents/planning/views/List.vue"),
      }, */
      // Reports
      {
        path: "result/finalresult",
        name: "reports.finalresult",
        component: () =>
          import("../documents/result/finalresult/views/List.vue"),
        meta: {
          permission: "view_report_result_final",
        },
      },
      // Registration
      {
        path: "teachers/students-per-class",
        name: "reports.students-per-class",
        component: () =>
          import("../reports/registration/students-per-class/views/List.vue"),
        meta: {
          permission: "view_students_per_class_report",
        },
      },
      {
        path: "teachers/students-per-class-customized",
        name: "reports.students-per-class-customized",
        component: () =>
          import(
            "../reports/registration/students-per-class-customized/views/List.vue"
          ),
        meta: {
          permission: "view_students_per_class_customized_report",
        },
      },
      {
        path: "teachers/students-per-integration",
        name: "reports.students-per-integration",
        component: () =>
          import(
            "../reports/registration/students-per-integration/views/List.vue"
          ),
        meta: {
          permission: "view_students_per_class_report",
        },
      },
      {
        path: "student-not-reenrolled",
        name: "reports.student-not-reenrolled",
        component: () =>
          import("../reports/registration/students-not-reenrolled/views/List.vue"),
        meta: {
          permission: "view_report_students_not_reenrolled",
        },
      },
      {
        path: "school/map-performance",
        name: "reports.map-performance",
        component: () =>
          import("../reports/registration/map-performance/views/List.vue"),
        meta: {
          permission: "view_map_performance",
        },
      },
      {
        path: "school/birthdays",
        name: "reports.birthdays",
        component: () =>
          import("../reports/registration/birthdays/views/List.vue"),
        meta: {
          permission: "view_report_students_birthday",
        },
      },
      {
        path: "school/students-per-neighborhood",
        name: "reports.students-per-neighborhood",
        component: () =>
          import(
            "../reports/registration/students-per-neighborhood/views/List.vue"
          ),
        meta: {
          permission: "view_report_students_per_neighborhood",
        },
      },

      // Registers
      {
        path: "time-table",
        name: "reports.time-table",
        component: () =>
          import("../reports/registers/time-table/views/List.vue"),
        meta: {
          permission: "view_teacher_time_table_report",
        },
      },
      {
        path: "reports/registers/deficiency",
        name: "reports.registers.deficiency",
        component: () =>
          import("../reports/registers/deficiency/views/List.vue"),
        meta: {
          permission: "view_report_deficiency",
        },
      },

      {
        path: "servers",
        name: "reports.servers",
        component: () => import("../reports/registers/servers/views/List.vue"),
        meta: {
          permission: "view_report_servers",
        },
      },
      {
        path: "school",
        name: "reports.school",
        component: () => import("../reports/registers/school/views/List.vue"),
        meta: {
          permission: "view_report_schools",
        },
      },
      {
        path: "classes",
        name: "reports.classes",
        component: () => import("../reports/registers/classes/views/List.vue"),
        meta: {
          permission: "view_report_classes",
        },
      },
      {
        path: "reports/registers/benefits",
        name: "reports.registers.benefits",
        component: () => import("../reports/registers/benefits/views/List.vue"),
        meta: {
          permission: "view_report_benefits",
        },
      },
      {
        path: "ocurrency-disciplinary",
        name: "reports.ocurrency-disciplinary",
        component: () =>
          import(
            "../reports/registers/student-disciplinary-occurrence/views/List.vue"
          ),
        meta: {
          permission: "view_occurrency_disciplinary",
        },
      },
      // Absence Conference
      {
        path: "absence-conference",
        name: "reports.absence-conference",
        component: () =>
          import("../reports/releases/absence-conference/views/List.vue"),
        meta: {
          permission: "view_absence_conference_report",
        },
      },
      // Absence Delay
      {
        path: "absences-delays",
        name: "reports.absences-delays",
        component: () =>
          import("../reports/releases/absences-delays/views/List.vue"),
        meta: {
          permission: "view_absent_delay",
        },
      },
      // Reports

      // Indicators
      {
        path: "student-performance",
        name: "reports.student-performance",
        component: () =>
          import("../reports/indicators/student-performance/views/List.vue"),
        meta: {
          permission: "view_report_student_performance",
        },
      },
      {
        path: "indicators/distortion-age-grade",
        name: "reports.indicators.distortion-age-grade",
        component: () =>
          import("../reports/indicators/distortion-age-grade/views/List.vue"),
        meta: {
          permission: "view_distortion_age_grade",
        },
      },
      {
        path: "student-per-school",
        name: "reports.student-per-school",
        component: () =>
          import("../reports/indicators/student-per-school/views/List.vue"),
        meta: {
          permission: "view_report_student_per_school",
        },
      },
      {
        path: "performance-school-moviment",
        name: "reports.performance-school-moviment",
        component: () =>
          import(
            "../reports/indicators/performance-school-moviment/views/List.vue"
          ),
        meta: {
          permission: "view_report_performance_school_moviment",
        },
      },
      {
        path: "class-average-comparison",
        name: "reports.class-average-comparison",
        component: () =>
          import(
            "../reports/indicators/class-average-comparison/views/List.vue"
          ),
        meta: {
          permission: "view_report_class_average_comparison",
        },
      },

      // Moviments
      {
        path: "student-enturms",
        name: "reports.student-enturms",
        component: () =>
          import("../reports/moviments/student-enturms/views/List.vue"),
        meta: {
          permission: "view_report_students_enturms",
        },
      },


    ],
  },
];
